<template>
  <div id="hrms15e-detail2">
    <div v-show="detail1Disp">
      <div v-if="!detailDisabled2">
        <div v-if="parseInt(detail.table.rows.length) > 0">
          <div class="detail detail-responsive">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC4']['90'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{detail.detail.codpos}} - {{detail.detail.nampos}}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC4']['100'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{detail.detail.codjob}} - {{detail.detail.namjob}}</div>
                </div>
              </div>
            </form>
            <div class="col-md-12 clear-padding">
              <div class="evaluation-wrapper">
                <template v-for="dataGroup in detail.table.rows">
                  <group  :labels="labels"
                          :dataGroup="dataGroup"
                          :labelsHrms15e="labelsHrms15e"
                          name="detail2"/>
                </template>
              </div>
            </div>
            <div class="col-md-12 clear-padding margin-b-5">
              <div class="evaluation-sum">
                {{ labels['HRAP31EC3']['190'] }} {{ calResultScore(detail.table.rows) }}/{{ calTotalScore(detail.table.rows) }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ labels['HRAP31EC4']['220'] }}</label>
                <textarea class="form-control"
                          v-model="detail.detail.commboss"
                          maxlength="600"
                          v-validate="'max:600'"
                          data-vv-name="commboss"
                          :has-error="errors.has('commboss')" ></textarea>
                <div class="text-error" v-show="errors.has('commboss')">{{errors.first('commboss')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ labels['HRAP31EC4']['230'] }}</label>
                <textarea class="form-control"
                          v-model="detail.detail.commemp"
                          maxlength="600"
                          v-validate="'max:600'"
                          data-vv-name="commemp"
                          :has-error="errors.has('commemp')"></textarea>
                <div class="text-error" v-show="errors.has('commemp')">{{errors.first('commemp')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div>
              </div>
            </div>
          </div>
          <div class="box-footer">
            <div class="col-md-6 clear-padding">
              <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
            </div>
            <div class="col-md-6 clear-padding">
              <div class="dropup" align="right">
                <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ labels['HRAP31EC3']['320'] }}
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu2">
                  <li class="cursor-pointer"><a @click="courseRequired()">{{ labels['HRAP31EC4']['250'] }}</a></li>
                  <li class="cursor-pointer" v-if="indexSelected.flgtypap === 'T'"><a @click="appraisalOthers()">{{ labels['HRAP31EC4']['260'] }}</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 clear-padding margin-b-5"  v-else >
          <div class="evaluation-sum ">
            <div class="form-group ">
              <label class="col-md-12 control-label align-c">{{ labelsHrms15e['C80'] }}</label>
            </div>
          </div>
        </div>
      </div>

      <div v-if="detailDisabled2">
        <template v-if="!isEmpty(detailTab2Desc2Selected)">
          <div class="detail detail-responsive clearfix">
            <div class="main-topic-box">
              <i class="left-arrow fa fa-angle-left" aria-hidden="true" @click="triggerSetDetailTab2Desc2Selected(-1)"></i>
              <div class="main-topic">{{ labels['HRAP31EC4']['30'] }} {{ detailTab2Desc2Selected.numseq }}</div>
              <i class="right-arrow fa fa-angle-right" aria-hidden="true" @click="triggerSetDetailTab2Desc2Selected(1)"></i>
            </div>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC4']['90'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{detailTab2Desc2Selected.codpos}} - {{detailTab2Desc2Selected.nampos}}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRAP31EC4']['100'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{detailTab2Desc2Selected.codjob}} - {{detailTab2Desc2Selected.namjob}}</div>
                </div>
              </div>
            </form>
            <div class="col-md-12 clear-padding">
              <div class="evaluation-wrapper">
                <template v-for="dataGroup in detailTab2Desc2Selected.table">
                  <group  :disabled="detailDisabled2"
                          :labels="labels"
                          :dataGroup="dataGroup"
                          :labelsHrms15e="labelsHrms15e"
                          name="detail2"/>
                </template>
              </div>
            </div>
            <div class="col-md-12 clear-padding margin-b-5">
              <div class="evaluation-sum">
                {{ labels['HRAP31EC3']['190'] }} {{ calResultScore(detailTab2Desc2Selected.table) }}/{{ calTotalScore(detailTab2Desc2Selected.table) }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ labels['HRAP31EC4']['220'] }}</label>
                <textarea class="form-control"
                          v-model="detailTab2Desc2Selected.commboss"
                          :disabled="detailDisabled2"
                          maxlength="600"
                          v-validate="'max:600'"
                          data-vv-name="commboss"
                          :has-error="errors.has('commboss')"></textarea>
                <div class="text-error" v-show="errors.has('commboss')">{{errors.first('commboss')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ labels['HRAP31EC4']['230'] }}</label>
                <textarea class="form-control"
                          v-model="detailTab2Desc2Selected.commemp"
                          :disabled="detailDisabled2"
                          maxlength="600"
                          v-validate="'max:600'"
                          data-vv-name="commemp"
                          :has-error="errors.has('commemp')"></textarea>
                <div class="text-error" v-show="errors.has('commemp')">{{errors.first('commemp')}}</div>
                <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="evaluation-sum ">
            <div class="form-group ">
              <label class="col-md-12 control-label align-c">{{ labelsHrms15e['C70'] }} {{ labels['HRAP31EC3']['230'] }}</label>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-show="detail1Desc1Disp">
      <detail2Desc1   :labels="labels"
                      :labelsButton="labelsButton"
                      :searchIndex="searchIndex"
                      :indexSelected="indexSelected"
                      :detail="detailCourse"
                      :popupCourseGap="popupCourseGap"
                      :detail2Desc1Table="detail2Desc1Table"
                      :courseGapPopupTable="courseGapPopupTable"
                      :nowLang="nowLang"
                      :receivedHrms15eDetailCourseAddInline="receivedHrms15eDetailCourseAddInline"
                      :receivedHrms15eCourseGapPopup="receivedHrms15eCourseGapPopup"
                      :postDetailCourseSave="postDetailCourseSave"
                      :setDetailCouresAddInlineAll="setDetailCouresAddInlineAll"
                      :validateStaappr="validateStaappr" />
    </div>
  </div>

</template>

<script>
import group from 'components/hrms15e/group2'
import detail2Desc1 from 'components/hrms15e/detail2Desc1'
import _ from 'lodash'
import { constLabels } from 'assets/js/constLabels.js'
import swal from 'sweetalert'

export default {
  name: 'hrms15e-detail2',
  props: [
    'detailDisabled',
    'setDetailDisabled',
    'detailDisabled2',
    'setDetailDisabled2',
    'labels',
    'labelsButton',
    'detail',
    'detailAll',
    'detailCourse',
    'toggle',
    'indexSelected',
    'searchIndex',
    'popupCourseGap',
    'detail2Desc1Table',
    'courseGapPopupTable',
    'receivedHrms15eDetailCourse',
    'receivedHrms15eDetailCourseAddInline',
    'receivedHrms15eCourseGapPopup',
    'receivedHrms15eDetail2Desc2',
    'postDetailCourseSave',
    'postDetail2Save',
    'setDetailCouresAddInlineAll',
    'setShowDetailDescDisp',
    'detail1Disp',
    'setDetail1Disp',
    'detail1Desc1Disp',
    'setDetail1Desc1Disp',
    'detailTab2Desc2',
    'detailTab2Desc2Selected',
    'setDetailTab2Desc2Selected',
    'detailTab2Desc2IndexSelected',
    'setDetailTab2Desc2IndexSelected',
    'validateStaappr',
    'labelsHrms15e',
    'checkCompleteAll',
    'calResultScore',
    'calTotalScore'
  ],
  data () {
    return {
      detailIndex: 0
    }
  },
  watch: {
    detailTab2Desc2IndexSelected () {
      this.detailIndex = this.detailTab2Desc2IndexSelected
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    isEmpty (detailTab2Desc2Selected) {
      return _.isEmpty(detailTab2Desc2Selected)
    },
    courseRequired () {
      let courseParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_numseq: this.indexSelected.numseq,
        p_codempid_query: this.indexSelected.codempid
      }
      window.scrollTo(0, 0)
      this.setShowDetailDescDisp(true)
      this.setDetail1Disp(false)
      this.setDetail1Desc1Disp(true)
      this.receivedHrms15eDetailCourse(courseParams)
    },
    appraisalOthers () {
      let detailParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_numseq: this.indexSelected.numseq,
        p_codempid_query: this.indexSelected.codempid
      }
      window.scrollTo(0, 0)
      this.setDetailDisabled(true)
      this.setDetailDisabled2(true)
      this.receivedHrms15eDetail2Desc2(detailParams)
    },
    triggerSetDetailTab2Desc2Selected (index) {
      this.detailIndex += index
      if (this.detailIndex < 0) {
        this.detailIndex = this.detailTab2Desc2.rows.length - 1
      }
      if (this.detailIndex > this.detailTab2Desc2.rows.length - 1) {
        this.detailIndex = 0
      }
      this.setDetailTab2Desc2IndexSelected(this.detailIndex)
      this.setDetailTab2Desc2Selected(this.detailTab2Desc2.rows[this.detailIndex])
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let _this = this
          swal({
            title: constLabels('confirmTitle'),
            text: constLabels('msgConfirmSave'),
            html: true,
            showCancelButton: true,
            closeOnConfirm: false,
            confirmButtonText: constLabels('ok'),
            cancelButtonText: constLabels('cancel')
          },
          function (isConfirm) {
            if (isConfirm) {
              // Check that every assessment is complete
              let flgComplete = _this.checkCompleteAll(_this.detail.table.rows)
              if (!flgComplete) {
                swal({
                  title: constLabels('confirmTitle'),
                  text: _this.labelsHrms15e['C100'],
                  html: true,
                  showCancelButton: true,
                  closeOnConfirm: false,
                  confirmButtonText: constLabels('ok'),
                  cancelButtonText: constLabels('cancel')
                },
                function (isConfirm2) {
                  if (isConfirm2) {
                    _this.processSave()
                  }
                })
              } else {
                _this.processSave()
              }
            }
          })
        }
      })
    },
    processSave () {
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      this.saveDetail2()
    },
    saveDetail2 (saveFromStatus) {
      let calQtyBeh = this.calResultScore(this.detailAll.tab1.table.rows) * 100 / this.calTotalScore(this.detailAll.tab1.table.rows)
      if (saveFromStatus) {
        this.detail.detail.qtybeh = isNaN(calQtyBeh) ? 0 : calQtyBeh
      } else {
        this.detail.detail.qtybeh = this.indexSelected.qtybeh
      }
      this.postDetail2Save({
        indexSelected: this.indexSelected,
        searchIndex: this.searchIndex,
        detail: this.detail.detail,
        table: this.detail.table
      })
    }
  },
  components: {
    group,
    detail2Desc1
  }
}
</script>




// WEBPACK FOOTER //
// detail2.vue?b9e72070